import { STATUS_NOTIFICATION_DEFAULT, STATUS_NOTIFICATION_SUCCESS, STATUS_NOTIFICATION_FAILURE } from './constants';
import { getActionTypes } from './get-actions';

export const getReducer = (actionPrefix) => (action) => ({
  // START
  [getActionTypes(actionPrefix).QUERY_START]: () => ({
    isWidgetLoading: true,
  }),
  [getActionTypes(actionPrefix).MUTATION_START]: () => ({
    isWidgetLoading: true,
    isMutationPending: true,
  }),

  // SUCCESS
  [getActionTypes(actionPrefix).QUERY_SUCCESS]: () => ({
    ...action.payload.data,
    selectedOptionsIds: action.payload.data.dataSubscriptions.list
      ?.filter((newsletter) => newsletter.isSubscribed)
      .map((newsletter) => newsletter.id),
    error: false,
    isWidgetLoading: false,
  }),
  // NOTE: a query will be launched after the mutation (we do not use subscriptions for newsletters)
  [getActionTypes(actionPrefix).MUTATION_SUCCESS]: () => ({
    error: false,
    isMutationPending: false,
    statusNotification: STATUS_NOTIFICATION_SUCCESS,
  }),

  // FAILURE
  [getActionTypes(actionPrefix).QUERY_FAILURE_GENERIC]: () => ({
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
    isWidgetLoading: false,
  }),
  [getActionTypes(actionPrefix).QUERY_FAILURE_401]: () => ({
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
  }),
  [getActionTypes(actionPrefix).MUTATION_FAILURE_GENERIC]: () => ({
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
    statusNotification: STATUS_NOTIFICATION_FAILURE,
    isMutationPending: false,
  }),
  [getActionTypes(actionPrefix).MUTATION_FAILURE_401]: () => ({
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
  }),

  // RESET
  [getActionTypes(actionPrefix).RESET_STATUS_NOTIFICATION]: () => ({
    statusNotification: STATUS_NOTIFICATION_DEFAULT,
  }),
  [getActionTypes(actionPrefix).RESET_LOADER]: () => ({
    isWidgetLoading: false,
  }),

  // USER INTERACTION
  [getActionTypes(actionPrefix).SELECT_OPTIONS]: () => ({
    selectedOptionsIds: action.payload.options,
  }),
  [getActionTypes(actionPrefix).SHOW_UNSUBSCRIBE_MODAL]: () => ({
    showUnsubscribeModal: action.payload.showUnsubscribeModal,
  }),
  [getActionTypes(actionPrefix).SHOW_NEWSLETTERS_FULL_SCREEN]: () => ({
    showNewslettersFullScreen: action.payload.showNewslettersFullScreen,
  }),
});
